<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'alunos' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Historico acadêmico
          <v-col cols="9" class="text-h5">
            Aluno(a) - {{ aluno.nomecompleto ? aluno.nomecompleto : " " }}
          </v-col>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9" class="pt-0 pb-0">
        <div class="d-flex mb-0">
          <v-btn color="success" @click="adicionarHistorico" class="mr-2">
            <v-icon left>mdi-plus</v-icon> Adicionar novo ano
          </v-btn>
          <v-btn color="success" @click="baixarHistorico" class="mr-2">
            <v-icon left>mdi-download</v-icon> Baixar Histórico
          </v-btn>
        </div>
      </v-col>
      <v-col cols="3" class="pt-0 pb-0">
        <v-text-field
          v-model="search"
          class="ml-2 search-input"
          append-icon="mdi-magnify"
          label="Pesquisar..."
          solo
          autofocus
          dense
          single-line
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <template v-if="historicoList.length === 0">
          <v-alert type="warning" class="mt-4"> Nenhum histórico encontrado. </v-alert>
        </template>
      </v-col>

      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="historicoList"
          :items-per-page="20"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <!-- Slot para quando a lista estiver vazia -->

          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr v-for="item of items" :key="item.id" class="text-uppercase">
                <td class="text-lowercase">{{ item.id }}</td>
                <td>{{ item.serie ? item.serie : "- - -" }}</td>
                <td>{{ item.ano ? item.ano : "- - -" }}</td>
                <td>{{ item.escola ? item.escola : "- - -" }}</td>
                <td>{{ item.municipio ? item.municipio : "- - -" }}</td>
                <td>{{ item.situacao ? item.situacao : "-" }}</td>
                <td>
                  <div v-if="item.flag" class="d-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="blue-grey lighten-3"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => editarHistorico(item.id)"
                        >
                          <v-icon small>fa fa-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Histórico</span>
                    </v-tooltip>

                    <v-tooltip color="error" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => deletarHistorico(item.id)"
                        >
                          <v-icon small>fa fa-trash</v-icon>
                        </v-btn>
                      </template>
                      <span>Apagar Histórico</span>
                    </v-tooltip>
                  </div>
                  <div v-else class="text-left">
                    <span class="text-caption grey--text"> Matrícula do sistema </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="grey" v-bind="attrs" v-on="on" class="ml-1">
                          mdi-information
                        </v-icon>
                      </template>
                      <span
                        >Esta matrícula foi gerada pelo sistema, a edição não é permitida em
                        históricos.</span
                      >
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </main-template>
</template>

<script lang="js">
import { dataTableFilter } from "@/plugins/searchQuery";

export default {
  data() {
    return {
      carregandoHistorico: false,
      dataTableFilter,
      search: "",
      aluno: "",
      historicoList: [],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Serie", value: "serie" },
          { text: "Ano de Conclusão", value: "ano" },
          { text: "Escola", value: "escola" },
          { text: "Cidade", value: "municipio" },
          { text: "Situação", value: "situacao" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  mounted() {
    this.carregarHistorico(this.$router.currentRoute.params.aluno_id);
  },
  methods: {
    async carregarHistorico(aluno_id) {
    this.carregandoHistorico = true;
    try {

      const response = await this.$services.historicoService.syncAll(aluno_id);
      if (!response.aluno || response.aluno.length === 0) {
        throw new Error('Nenhuma matrícula encontrada para este aluno');
      }

      if (!response.aluno[0].aluno) {
        console.error('Estrutura de dados inesperada:', response.aluno[0]);
        throw new Error('Dados do aluno não encontrados na matrícula');
      }

      this.aluno = response.aluno[0].aluno;

      const listaFundamental = response.historicoExternoFundamental.map((historicoItem) => ({
          id: historicoItem.id,
          serie: historicoItem.serie,
          ano: historicoItem.ano,
          escola: historicoItem.escola,
          municipio: historicoItem.municipio,
          flag: true,
      }));

      const listaEja = response.historicoExternoEja.map((historicoItem) => ({
          id: historicoItem.id,
          serie: historicoItem.serie,
          ano: historicoItem.ano,
          escola: historicoItem.escola,
          municipio: historicoItem.municipio,
          flag: true,
      }));

      // Combinando as duas listas
      let lista = listaFundamental.concat(listaEja);

      lista.forEach((item) => {
        this.historicoList.push(item);
      });

      lista = Object.values(response.historicoDoSistema).map((historicoItem) => ({
        id: historicoItem.id,
        serie: historicoItem?.turma?.descricao ?? 'N/A',
        ano: historicoItem?.ano?.descricao ?? 'N/A',
        escola: historicoItem?.turma?.franquia?.descricao ?? 'N/A',
        municipio: historicoItem?.turma?.franquia?.cidade ?? 'N/A',
        situacao: historicoItem?.situacao ?? '-',
        flag: false,
      }));

      lista.forEach((item) => {
        if (item.municipio === 'N/A' || item.escola === 'N/A') {
          console.warn(`Matrícula ${item.id}: dados incompletos (turma pode estar deletada)`, item);
        }
        this.historicoList.push(item);
      });


    } catch (error) {
      const mensagemErro = error.message || "Matrícula do aluno não encontrada!";
      this.$toast.danger(mensagemErro);
    } finally {
      this.carregandoHistorico = false;
    }
    },

    adicionarHistorico() {
      this.$router.push({ name: "historico.create" });
    },
    editarHistorico(historico_id) {
      this.$router.push({ name: "historico.edit", params: { historico_id } });
    },
    async deletarHistorico(historico_id) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta item?",
        confirmationCode: historico_id,
        confirmationMessage: `Por favor, digite <strong>${historico_id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando item do historico");
              try {
                await this.$services.historicoService.deletarItem(historico_id);
                this.$toast.success("Historico deletado com sucesso");
                this.$router.go(0);
                // this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    async baixarHistorico() {
      try {
        this.$loaderService.open("Gerando Histórico...");
        await this.$services.historicoService.baixarHistorico(this.$router.currentRoute.params.aluno_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
  watch: {
    carregandoHistorico(value) {
      if (value && this.historicoList.length === 0) {
        this.$loaderService.open("Carregando histórico");
      } else {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style></style>
